export enum SurveyFilter {
  None = 0,
  ByAppraisee = 1,
  ByOthers = 2 
}